import { CxEvent } from '@spartacus/core';

export class Ga4GgScrollEvent extends CxEvent {
  event?: string;
  scroll_percent?: string;
}
